export type StrToStrArrayMap = { [key: string]: string[] };

const type1_1: StrToStrArrayMap = {
	/// Type1_1
	bathroom_kitchen_sink_single_or_double: ["Single", "Double"],
	general_hvac_boiler_unit_furnace: ["Unit", "Furnace"],
	general_hvac_ductwork_system_home_sf: ["(Home SF)"],
	appliances_range_gas_electric: ["(Gas)", "(Electric)"],
	general_hvac_heat_ac_register: ["Heat", "AC"],
	kitchen_cabinetry_filler_scribe_board: ["Filler", "scribe"],
	bathroom_kitchen_tub_shower_surround: ["Tub", "Shower"],
	plumbing_rough_in_per_fixture: ["(Per Fixture)"],
	kitchen_cabinetry_flat_laid_backsplash_4_6_: ['4"', '6"'],
	laundry_room_dryer_gas_or_electric: ["(gas)", "(electric)"],
};

export const selectablesMap: StrToStrArrayMap = {
	simulated_header_debris_pickup_tandem_dump_dump_truck_dumpster_12_20_30_40: [
		"PickUp,",
		"Tandem",
		"Truck,",
		"Dumpster",
		"(12)",
		"(20)",
		"(30)",
		"(40)",
	],
	simulated_header_program_work_adjuster_direct_private: ["(Program Work)", "(Adjuster Direct)", "(Private)"],
	paint_and_stain_masking_sf_lf: ["(SF)", "(LF)"],
	contents_manipulation_room_size_hours: ["(Room Size)", "(Hours)"],
	contents_pack_out_yes: ["(YES)"],
	contents_boxes_s_m_l: ["(S)", "(M)", "(L)"],
	contents_window_drapes_detach_reset: ["(detach", "reset)"],
	paint_and_stain_door_slab_sides: ["(Sides)"],
	paint_and_stain_opening_window_or_door: ["(window", "door)"],
	electrical_smoke_co_detector: ["Smoke", "CO Detector"],
	walls_and_ceiling_wall_insulation_r_13_r_15_r_19: ["(R-13)", "(R-15)", "(R-19)"],
	paint_and_stain_opening_window_or_door_large: ["(Large)", "(window", "door)"],
	walls_and_ceiling_ceiling_insulation_r_30_r_38: ["(R-30)", "(R-38)"],
	paint_and_stain_concrete_floor_wall: ["(Floor)", "(Wall)"],
	walls_and_ceiling_drywall_lf_1_2_or_5_8_flood_cuts_2ft_or_4ft: ["1/2", "5/8", "2ft", "4ft", "(flood cuts)"],
	walls_and_ceiling_drywall_1_2_or_5_8: ["1/2", "5/8"],
	walls_and_ceiling_drywall_tape_joint_repair_per_lf: ["joint", "repair"],
	walls_and_ceiling_cement_board_1_4_or_1_2: ["(1/4)", "(1/2)"],
	walls_and_ceiling_plaster_coats_1_2_3_or_blueboard: ["(1)", "(2)", "(3)", "Blueboard"],
	finish_trim_baseboards_size_: ["(Size)"],
	electrical_outlet_switch_covers: ["Outlet", "Switch"],
	electrical_outlet_switch: ["Outlet", "Switch"],
	walls_and_ceiling_ceiling_tile_acoustic_suspended_2x2_2_4: ["(acoustic)", "(suspended)", "(2x2)", "(2x4)"],
	finish_trim_crown_molding_size_: ["(Size)"],
	walls_and_ceiling_ceiling_grid_2x2_or_2x4: ["(2x2)", "(2x4)"],
	finish_trim_chair_rail_size_: ["(Size)"],
	finish_trim_casing_size_: ["(Size)"],
	walls_and_ceiling_skim_coat_light_regular_heavy: ["(light)", "(regular)", "(heavy)"],
	doors_and_windows_int_pre_hung_door_type: ["(type)"],
	doors_and_windows_ext_pre_hung_door_type: ["(type)"],
	walls_and_ceiling_paneling_size_: ["(Size)"],
	finish_trim_vinyl_base_molding_4_inch_6_inch: ["(4 inch)", "(6 inch)"],
	finish_trim_trim_board_size: ["(size)"],
	doors_and_windows_window_wood_vinyl_style_: ["(wood)", "(Vinyl)", "Style="],
	plumbing_radiator_unit_size: ["Unit", "Size"],
	plumbing_radiator_cover_size: ["Cover", "Size"],
	flooring_wood_flooring_hw_eng_lam: ["(HW)", "(ENG)", "(LAM)"],
	flooring_vinyl_sheet_roll: ["(roll)"],
	flooring_vinyl_self_adhesive: ["(self adhesive)"],
	flooring_step_charge_for_tucked_per_rise: ["(per rise)"],
	flooring_underlayment_subfloor: ["Underlayment", "Subfloor"],
	flooring_cement_board_1_4_or_1_2: ["( 1/4)", "(1/2)"],
	flooring_threshold_wood_mtl_cult_marble_marble: ["(wood)", "(MTL)", "(cult marble)", "(marble)"],
	flooring_level_concrete_light_avg_heavy: ["(Light)", "(Avg)", "(Heavy)"],
	...type1_1,
};

export const selectablesMapForType: { [key: string]: StrToStrArrayMap } = {
	Type1: selectablesMap,
	Type1_1: type1_1,
};
